import RecruitmentSubmissionDrawer from "@/components/recruitment/RecruitmentSubmissionDrawer.vue";
import RecruitmentSubmissionStatusButton from "@/components/recruitment/RecruitmentSubmissionStatusButton.vue";
import { readStoredRecruitmentRoles } from "@/Utile/recruitmentSubmissions.mjs";

const SUBMISSION_WRITE_ROLES = [
  "admin",
  "miniadmin",
  "hr",
  "vacation-hr",
  "recruiter-default",
  "recruiter-hr",
];

export default {
  components: { RecruitmentSubmissionDrawer, RecruitmentSubmissionStatusButton },
  data() {
    return {
      submissionDrawerOpen: false,
      selectedApplicationId: null,
      submissionInitialTab: "compose",
    };
  },
  computed: {
    canSubmitCandidates() {
      const roles = readStoredRecruitmentRoles();
      return SUBMISSION_WRITE_ROLES.some((role) => roles.has(role));
    },
  },
  methods: {
    openSubmission(item) {
      this.selectedApplicationId = item?.id || null;
      this.submissionInitialTab = item?.submission_status === "not_sent" ? "compose" : "history";
      this.submissionDrawerOpen = Boolean(this.selectedApplicationId);
    },
    handleSubmissionSent(payload) {
      if (typeof this.onRecruitmentSubmissionSent === "function") {
        this.onRecruitmentSubmissionSent(payload);
      }
    },
  },
};
